// 从环境变量获取 API 地址，默认为 localhost:8000
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000'; 